
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investments/car-rental",
      function () {
        return require("private-next-pages/investments/car-rental.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investments/car-rental"])
      });
    }
  